// extracted by mini-css-extract-plugin
module.exports = {"RegisterForm":"RegisterForm_RegisterForm__2uehZ"};